import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';

import { environment } from '@env/environment';
import user from '@assets/menu/menu.json';

import { User } from './user.model';
import { BaseService } from '../core/base.service';
import { ApiConstants } from '@app/api-constants';
import { UtilService } from '@app/core/util.service';
import { AppGlobalService } from '@app/app-global.service';
import { AppLoaderService } from '@app/shared/services/app-loader.service';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  public currentUser: User;
  constructor(
    private bs: BaseService,
    private util: UtilService,
    private appGlobal: AppGlobalService,
    private loader: AppLoaderService,
    private http: HttpClient
  ) { }

  /**
   * Authenticates the user.
   *
   * Important: For SAML we MUST trigger a full browser navigation to the authenticate endpoint
   * so server-side redirect -> /saml/login -> Microsoft works. Do NOT use XHR here.
   */
  public authenticate(): Observable<any> {
  this.loader.show();

  if (environment.prototype) {
    const prototypeUser = user;
    this.appGlobal.write('prototyping', true);
    this.appGlobal.write('currentUser', prototypeUser);
    this.loader.hide();
    return of(prototypeUser);
  }

  // 1️⃣ Try fetching user via XHR first
  return this.http.get<User>('/rest/appuserprivileges/authenticate').pipe(
    tap(data => {
      // SUCCESS → user already authenticated → do NOT redirect
      this.setCurrentUser(data);
      console.log('[Auth] XHR success, user loaded without redirect.');
    }),

    catchError(err => {
      // 2️⃣ Only if XHR fails → full redirect to start SAML flow
      console.warn('[Auth] XHR failed → triggering SAML redirect');

      window.location.href = '/rest/appuserprivileges/authenticate';

      return of(null);
    })
  );
}

  public getfsToken = () => {
    const currentUserToken = new Observable(observer => {
      this.http.get('rest/firebase/usertoken', { responseType: 'text' }).subscribe(
        (token) => {
          observer.next(token);
        },
        (error: any) => {
          this.loader.hide();
          observer.error(error);
        }
      );
    });
    return currentUserToken;
  }

  public setCurrentUser(data: User): void {
    this.currentUser = data;
    this.appGlobal.write('prototyping', environment.prototype);
    this.appGlobal.write('currentUser', data);
    this.loader.hide();
  }

  public getcurrentUser(): User {
    return this.currentUser;
  }

  public logout(): void {
    // TODO
  }

}
